import { type MouseEvent } from 'react';

import { TreeMap, type TreeMapItem } from '@cast/design-system';

import { ClusterReliabilityHeatmapTooltip } from './ClusterReliabilityHeatmapTooltip';
import type { ClusterHeatmapItem } from '../utils/clusterHeatmap';

type ClusterHeatmapProps = {
  data: ClusterHeatmapItem[];
  onClusterClick: (clusterId: string, clickEvent?: MouseEvent<Element>) => void;
};

const toTreeMapItem = (item: ClusterHeatmapItem): TreeMapItem => {
  const nodeCountLabel =
    item.nodeCount && item.nodeCount > 0
      ? `${item.nodeCount} node${item.nodeCount !== 1 ? 's' : ''}`
      : 'No node data';

  const tooltip =
    item.reliabilityMetrics != null ? (
      <ClusterReliabilityHeatmapTooltip
        clusterName={item.name}
        displayStatus={item.displayStatus}
        displayStatusLabel={item.displayStatusLabel}
        metrics={item.reliabilityMetrics}
      />
    ) : undefined;

  return {
    id: item.id,
    name: item.name,
    value: item.value,
    color: item.color,
    textColor: item.textColor,
    subtitle: nodeCountLabel,
    footer: item.footerLabel,
    borderDashed: item.dashedBorder,
    tooltip,
  };
};

export const ClusterHeatmap = ({
  data,
  onClusterClick,
}: ClusterHeatmapProps) => {
  return (
    <TreeMap
      data={data.map(toTreeMapItem)}
      onCellClick={onClusterClick}
      testId="cluster-heatmap"
    />
  );
};
